import { ListContent, Logger } from '@wolfdanepug/common-react'
import { useEffect, useMemo } from 'react'
import RadioControls from './RadioControls'
import { SegmentComponentProps } from '../types'
import { useQuery } from '../lib/useQuery'

export default function Activity({ data, setCanStepForward, isMobile }: SegmentComponentProps) {
	useEffect(() => {
		Logger.log('[Activity] data', data)
	}, [data])

	// the dog object
	const dog = useMemo(() => {
		const key = data?.dogs?.[data.activeDogContext]
		if (!key) return undefined
		const dogData = data?.dog[key]
		return dogData
	}, [data])

	// the activity levels
	const { data: activities } = useQuery(ListContent, {
		filter: { name: 'ActivityLevel' },
		limit: 1000
	})

	return (
		<>
			<RadioControls
				name={['activityLevel', 'dog']}
				value={dog?.activityLevel || ''}
				options={
					activities?.items.map((item: any) => ({
						label: item.title,
						value: item.value
					})) || []
				}
				sx={{
					gap: { xs: 2, md: 5 },
					flexDirection: isMobile ? 'column' : 'row'
				}}
				row={true}
				onChange={() => setCanStepForward(true)}
			/>
		</>
	)
}
